import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/components/base/SectionHeading";

export default function HelpCenter() {
  const { t } = useTranslation();

  const helpItems = [
    {
      title: t("help.i1Title"),
      desc: t("help.i1Desc"),
      icon: "ri-rocket-2-line",
      tone: "bg-primary-100 text-primary-700",
      to: "/help#quickstart",
    },
    {
      title: t("help.i2Title"),
      desc: t("help.i2Desc"),
      icon: "ri-question-answer-line",
      tone: "bg-accent-100 text-accent-700",
      to: "/help#faq",
    },
    {
      title: t("help.i3Title"),
      desc: t("help.i3Desc"),
      icon: "ri-book-open-line",
      tone: "bg-secondary-100 text-secondary-900",
      to: "/help#guides",
    },
    {
      title: t("help.i4Title"),
      desc: t("help.i4Desc"),
      icon: "ri-customer-service-2-line",
      tone: "bg-primary-100 text-primary-700",
      to: "/help#contact",
    },
  ];

  return (
    <section id="help" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          align="center"
          eyebrow={t("help.eyebrow")}
          title={t("help.title")}
          description={t("help.description")}
        />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {helpItems.map((item, index) => (
            <Link
              key={item.title}
              to={item.to}
              className="lh-fade-up group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-md ${item.tone}`}>
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                {t("help.viewDetail")}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-accent-50 px-6 py-6 text-center sm:flex-row sm:text-left">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-accent-950">
              <i className="ri-mail-send-line text-xl" />
            </span>
            <div>
              <p className="font-heading text-base font-semibold text-foreground-950">{t("help.noAnswer")}</p>
              <p className="mt-0.5 text-sm text-foreground-600">{t("help.contactDesc")}</p>
            </div>
          </div>
          <Link
            to="/help#contact"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-contacts-book-2-line" />
            </span>
            {t("help.contact")}
          </Link>
        </div>
      </div>
    </section>
  );
}